export default "__VITE_ASSET__D5077DPS__"